import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { saveUserDetail, editUserDetail, deleteUserDetail } from './api'
import { InitialState, OnChangeHandler } from './types'

const initialState: InitialState = {
  isLoading: false,
  studentInformation: {
    dob: '' 
  }
}

export const userDetailSlice = createSlice({
  name: 'userDetail',
  initialState,
  reducers: {
    updateStudentInformation: (
      state,
      action: PayloadAction<OnChangeHandler>
    ) => {
      const key = Object.keys(action.payload)[0]
      const studentInfo = {
        ...state.studentInformation,
        [key]: action.payload[key]
      }
      state.studentInformation = studentInfo
    }
  },
  extraReducers: {
    [saveUserDetail.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [saveUserDetail.fulfilled.toString()]: (state) => {
      state.isLoading = false
    },
    [saveUserDetail.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [editUserDetail.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [editUserDetail.fulfilled.toString()]: (state) => {
      state.isLoading = false
    },
    [editUserDetail.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [deleteUserDetail.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [deleteUserDetail.fulfilled.toString()]: (state) => {
      state.isLoading = false
    },
    [deleteUserDetail.rejected.toString()]: (state) => {
      state.isLoading = false
    }
  }
})

export default userDetailSlice.reducer
